function normalizeList(value) {
  if (!value) return [];
  if (Array.isArray(value)) return value.filter(Boolean);
  return String(value)
    .split(',')
    .map(v => v.trim())
    .filter(Boolean);
}

function formatInr(value) {
  const num = Number(value);
  if (!Number.isFinite(num) || num <= 0) return '';
  return `₹${Math.round(num).toLocaleString('en-IN')}`;
}

function formatRange(from, to, suffix = '') {
  const fromNum = Number(from);
  const toNum = Number(to);
  const hasFrom = Number.isFinite(fromNum) && fromNum > 0;
  const hasTo = Number.isFinite(toNum) && toNum > 0;
  if (hasFrom && hasTo) return `${fromNum} - ${toNum}${suffix}`;
  if (hasFrom) return `${fromNum}+${suffix}`;
  if (hasTo) return `Up to ${toNum}${suffix}`;
  return '—';
}

function educationList(job) {
  if (job?.educationalQualifications?.length) return job.educationalQualifications;
  const legacy = String(job?.educationalQualification || '').trim();
  if (!legacy) return [];
  return legacy.includes(';')
    ? legacy.split(';').map(s => s.trim()).filter(Boolean)
    : [legacy];
}

export default function JobOpeningDetailBody({ job, showStaffFields = false }) {
  if (!job) return null;

  const mustTech = normalizeList(job.mustHaveTechnicalSkills);
  const niceTech = normalizeList(job.niceToHaveTechnicalSkills);
  const ageGroups = normalizeList(job.ageGroups);
  const workingModes = normalizeList(job.preferredWorkingModes);

  return (
    <div className="space-y-2 text-sm text-[hsl(var(--ds-fg))]">
      {showStaffFields && (
        <>
          <p>
            <strong>Job ID:</strong> {job.id || '—'}
          </p>
          <p>
            <strong>Client:</strong> {job.clientName || job.clientId || '—'}
          </p>
          <p>
            <strong>Recruiter:</strong> {job.recruiterName || job.recruiterId || '—'}
          </p>
        </>
      )}
      <p>
        <strong>Location:</strong> {job.location || '—'}
      </p>
      <p>
        <strong>Employment type:</strong> {job.employmentType || '—'}
      </p>
      <p>
        <strong>Number of positions:</strong> {job.numberOfPositions || 1}
      </p>
      <p>
        <strong>Budget:</strong>{' '}
        {formatInr(job.budgetFrom) || formatInr(job.budgetTo)
          ? `${formatInr(job.budgetFrom) || '—'}${job.budgetFrom && job.budgetTo ? ' - ' : ''}${formatInr(job.budgetTo) || ''}`
          : '—'}
      </p>
      <p>
        <strong>Experience:</strong> {formatRange(job.experienceFrom, job.experienceTo, ' yrs')}
      </p>
      <p>
        <strong>Notice period:</strong> {job.noticePeriod || '—'}
      </p>
      <p>
        <strong>Weekly working days:</strong> {job.weeklyWorkingDays || '—'}
      </p>
      <p>
        <strong>Educational qualification:</strong> {educationList(job).join('; ') || '—'}
      </p>
      {showStaffFields && (
        <>
          <p>
            <strong>Preferred gender:</strong> {job.preferredGender || 'Any'}
          </p>
          <p>
            <strong>Preferred age group:</strong> {ageGroups.length ? ageGroups.join(', ') : '—'}
          </p>
          <p>
            <strong>Preferred working mode:</strong>{' '}
            {workingModes.length ? workingModes.join(', ') : '—'}
          </p>
        </>
      )}
      <p>
        <strong>Priority:</strong> {job.priority || '—'}
      </p>
      <p>
        <strong>Status:</strong> {job.status || '—'}
      </p>
      <p>
        <strong>Core Competencies (must-have):</strong>{' '}
        {normalizeList(job.mustHaveSkills).length
          ? normalizeList(job.mustHaveSkills).join(', ')
          : '—'}
      </p>
      <p>
        <strong>Core Competencies (nice-to-have):</strong>{' '}
        {normalizeList(job.niceToHaveSkills).length
          ? normalizeList(job.niceToHaveSkills).join(', ')
          : '—'}
      </p>
      <p>
        <strong>Technical Skills (must-have):</strong>{' '}
        {mustTech.length ? mustTech.join(', ') : '—'}
      </p>
      <p>
        <strong>Technical Skills (nice-to-have):</strong>{' '}
        {niceTech.length ? niceTech.join(', ') : '—'}
      </p>
      <p>
        <strong>Benefits:</strong>{' '}
        {normalizeList(job.benefits).length ? normalizeList(job.benefits).join(', ') : '—'}
      </p>
      {job.description && (
        <p>
          <strong>Description:</strong> {job.description}
        </p>
      )}
    </div>
  );
}
